import React, { useCallback, useEffect, useState } from 'react';
import { sablonListe, sablonEkle, sablonGuncelle, sablonDurum,
         sesListe, sesEkle, sesDurum } from '../../services/reklamApi';

// CREATOMATE ŞABLONLARI — kullanıcı talebi: 2026-08-24.
// "Yeni template oluştur dediğimde benden template id istesin, hangi reklam türlerinde
// kullanılacağını checkbox'larla işaretleyip ekle diyeyim."
//
// Şablonun tasarımını insan yapar; sistem yalnızca alanları doldurur. Bir şablonun hangi
// üretim türünde kullanılabileceği burada belirlenir:
//   A = resim reklamı · B = resimden video · C = videodan video
export default function Sablonlar() {
  const [liste, setListe] = useState([]);
  const [durum, setDurum] = useState('yukleniyor');
  const [mesaj, setMesaj] = useState('');

  // Yeni şablon formu
  const [yeniId, setYeniId] = useState('');
  const [yeniAd, setYeniAd] = useState('');
  const [yeniNot, setYeniNot] = useState('');
  const [secim, setSecim] = useState({ resim: true, resimdenVideo: false, videodanVideo: false });

  // SESLENDİRME SESLERİ (kullanıcı talebi: 2026-08-25): "ben isim vereyim, ElevenLabs'tan
  // alıp kimliği getireyim". Ses eklemek artık deploy gerektirmiyor.
  const [sesler, setSesler] = useState([]);
  const [sesAd, setSesAd] = useState('');
  const [sesEtiket, setSesEtiket] = useState('');
  const [sesKimlik, setSesKimlik] = useState('');

  const yukle = useCallback(() => {
    setDurum('yukleniyor');
    sablonListe()
      .then(r => { setListe(r.data.sablonlar || []); setDurum('hazir'); })
      .catch(e => { setMesaj('✗ ' + (e.response?.data?.hata || e.message)); setDurum('hata'); });
  }, []);

  useEffect(() => { yukle(); }, [yukle]);

  const ekle = () => {
    setMesaj('Ekleniyor...');
    sablonEkle({
      sablonId: yeniId.trim(),
      ad: yeniAd.trim() || undefined,
      resim: secim.resim,
      resimdenVideo: secim.resimdenVideo,
      videodanVideo: secim.videodanVideo,
      kompozisyonNotu: yeniNot.trim() || undefined,
    })
      .then(() => {
        setYeniId(''); setYeniAd(''); setYeniNot('');
        setSecim({ resim: true, resimdenVideo: false, videodanVideo: false });
        setMesaj('✓ Şablon eklendi.');
        yukle();
      })
      .catch(e => setMesaj('✗ ' + (e.response?.data?.hata || e.message)));
  };

  // Var olan şablonun kullanım kuralını değiştirir (checkbox tıklanınca anında kaydeder).
  const kullanimDegistir = (s, harf) => {
    const mevcut = (s.kullanim || '').split('');
    const yeni = mevcut.includes(harf) ? mevcut.filter(h => h !== harf) : [...mevcut, harf];
    if (yeni.length === 0) { setMesaj('✗ En az bir kullanım türü seçili kalmalı.'); return; }

    sablonGuncelle(s.id, {
      resim: yeni.includes('A'),
      resimdenVideo: yeni.includes('B'),
      videodanVideo: yeni.includes('C'),
      ad: s.ad,
      kompozisyonNotu: s.kompozisyonNotu,
    })
      .then(() => { setMesaj('✓ Güncellendi.'); yukle(); })
      .catch(e => setMesaj('✗ ' + (e.response?.data?.hata || e.message)));
  };

  const sesleriYukle = useCallback(() => {
    sesListe().then(r => setSesler(r.data.sesler || [])).catch(() => setSesler([]));
  }, []);
  useEffect(() => { sesleriYukle(); }, [sesleriYukle]);

  const sesiEkle = () => {
    setMesaj('Ses ekleniyor...');
    sesEkle({ ad: sesAd.trim(), etiket: sesEtiket.trim() || undefined, sesKimligi: sesKimlik.trim() })
      .then(() => {
        setSesAd(''); setSesEtiket(''); setSesKimlik('');
        setMesaj('✓ Ses eklendi.');
        sesleriYukle();
      })
      .catch(e => setMesaj('✗ ' + (e.response?.data?.hata || e.message)));
  };

  const KUTU = { border: '1px solid var(--border)', borderRadius: 6, padding: '6px 9px', fontSize: 13 };
  const TURLER = [
    { harf: 'A', ad: 'Resim reklamı', anahtar: 'resim' },
    { harf: 'B', ad: 'Resimden video', anahtar: 'resimdenVideo' },
    { harf: 'C', ad: 'Videodan video', anahtar: 'videodanVideo' },
  ];

  return (
    <div style={{ maxWidth: 900 }}>
      <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 4 }}>Creatomate Şablonları</h3>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 14 }}>
        Tasarımı siz yaparsınız, sistem yalnızca alanları doldurur. Her şablonun hangi üretim
        türünde kullanılabileceğini burada işaretlersiniz. Öğe adları her şablonda aynı olmalı:
        <strong> RESIM, VIDEOM, BASLIK, ACIKLAMA-1, ACIKLAMA-2, SES, MUSIC</strong>.
      </div>

      {mesaj && (
        <div style={{
          fontSize: 12.5, fontWeight: 600, marginBottom: 12, padding: '8px 11px', borderRadius: 6,
          background: mesaj.startsWith('✗') ? '#FDECEA' : '#EAF6F0',
          color: mesaj.startsWith('✗') ? '#C0392B' : '#1D7A56',
          border: `1px solid ${mesaj.startsWith('✗') ? '#E6A9A2' : '#9FD3BB'}`,
        }}>{mesaj}</div>
      )}

      {/* YENİ ŞABLON */}
      <div style={{
        background: '#fff', border: '1px solid var(--border)', borderRadius: 8,
        padding: 16, marginBottom: 20,
      }}>
        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>Yeni şablon ekle</div>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 3 }}>Şablon kimliği (template_id)</div>
            <input value={yeniId} onChange={e => setYeniId(e.target.value)}
              placeholder="dba06fce-f5e6-4393-8851-8a9374cb144f"
              style={{ ...KUTU, width: 330, fontFamily: 'monospace' }} />
          </div>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 3 }}>Adı (isteğe bağlı)</div>
            <input value={yeniAd} onChange={e => setYeniAd(e.target.value)}
              placeholder="Şablon 04" style={{ ...KUTU, width: 180 }} />
          </div>
        </div>

        <div style={{ fontSize: 11.5, fontWeight: 600, marginBottom: 5 }}>Hangi reklam türlerinde kullanılsın?</div>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 10 }}>
          {TURLER.map(t => (
            <label key={t.harf} style={{ fontSize: 12.5, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}>
              <input type="checkbox" checked={secim[t.anahtar]}
                onChange={e => setSecim(s => ({ ...s, [t.anahtar]: e.target.checked }))} />
              {t.ad}
            </label>
          ))}
        </div>

        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 3 }}>
            Kompozisyon kuralı (isteğe bağlı) — brief yazılırken yapay zekaya bu kural verilir
          </div>
          <textarea value={yeniNot} onChange={e => setYeniNot(e.target.value)} rows={2}
            placeholder="Örn: Sol yarıda tasarım şekilleri var; görselin öznesi sağ yarıda olmalı."
            style={{ ...KUTU, width: '100%', maxWidth: 620, resize: 'vertical' }} />
        </div>

        <button onClick={ekle} disabled={yeniId.trim().length < 10} style={{
          background: yeniId.trim().length < 10 ? '#E4E9EA' : '#1D9E75',
          color: yeniId.trim().length < 10 ? '#9AA7AC' : '#fff',
          border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 13, fontWeight: 600,
          cursor: yeniId.trim().length < 10 ? 'default' : 'pointer',
        }}>Ekle</button>
      </div>

      {/* KAYITLI ŞABLONLAR */}
      {durum === 'yukleniyor' && <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>⏳ Yükleniyor...</div>}

      {durum === 'hazir' && (
        <div style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden' }}>
          {liste.length === 0 ? (
            <div style={{ padding: 16, fontSize: 13, color: 'var(--text-muted)' }}>Henüz şablon eklenmemiş.</div>
          ) : liste.map(s => (
            <div key={s.id} style={{
              padding: '12px 14px', borderBottom: '1px solid var(--border)',
              opacity: s.aktif ? 1 : 0.55,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                <strong style={{ fontSize: 13 }}>{s.ad}</strong>
                <span style={{ fontSize: 10.5, color: 'var(--text-muted)', fontFamily: 'monospace' }}>
                  {s.sablonId}
                </span>
                <button onClick={() => sablonDurum(s.id, !s.aktif).then(yukle)} style={{
                  marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer',
                  fontSize: 11, color: s.aktif ? '#C0392B' : '#1D7A56', textDecoration: 'underline',
                }}>{s.aktif ? 'devre dışı bırak' : 'geri aç'}</button>
              </div>

              <div style={{ display: 'flex', gap: 16, marginTop: 7, flexWrap: 'wrap' }}>
                {TURLER.map(t => (
                  <label key={t.harf} style={{ fontSize: 12, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5 }}>
                    <input type="checkbox" checked={(s.kullanim || '').includes(t.harf)}
                      onChange={() => kullanimDegistir(s, t.harf)} />
                    {t.ad}
                  </label>
                ))}
              </div>

              {s.kompozisyonNotu && (
                <div style={{ fontSize: 10.5, color: 'var(--text-muted)', marginTop: 6, maxWidth: 640 }}>
                  Kural: {s.kompozisyonNotu}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* SESLENDİRME SESLERİ — video reklamlarında 2. aşamada bu listeden seçilir. */}
      <div style={{
        background: '#fff', border: '1px solid var(--border)', borderRadius: 8,
        padding: 16, marginTop: 24,
      }}>
        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>Seslendirme sesleri</div>
        <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 12 }}>
          Video reklamının seslendirme aşamasında bu listeden seçim yaparsınız. Yeni bir ses
          eklemek için ElevenLabs&apos;ta sesi seçip <strong>Voice ID</strong> değerini buraya girin.
          Ses silinmez; kullanılmayacaksa devre dışı bırakılır (eski içerikler o adla üretilmişti).
        </div>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: 14 }}>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 3 }}>Ses adı</div>
            <input value={sesAd} onChange={e => setSesAd(e.target.value)}
              placeholder="Mert" style={{ ...KUTU, width: 150 }} />
          </div>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 3 }}>Açıklama (isteğe bağlı)</div>
            <input value={sesEtiket} onChange={e => setSesEtiket(e.target.value)}
              placeholder="Genç erkek" style={{ ...KUTU, width: 170 }} />
          </div>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 3 }}>ElevenLabs Voice ID</div>
            <input value={sesKimlik} onChange={e => setSesKimlik(e.target.value)}
              placeholder="21m00Tcm4TlvDq8ikWAM" style={{ ...KUTU, width: 260, fontFamily: 'monospace' }} />
          </div>
          <button onClick={sesiEkle} disabled={sesAd.trim().length < 2 || sesKimlik.trim().length < 10} style={{
            background: (sesAd.trim().length < 2 || sesKimlik.trim().length < 10) ? '#E4E9EA' : '#1D9E75',
            color: (sesAd.trim().length < 2 || sesKimlik.trim().length < 10) ? '#9AA7AC' : '#fff',
            border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 13, fontWeight: 600,
            cursor: (sesAd.trim().length < 2 || sesKimlik.trim().length < 10) ? 'default' : 'pointer',
          }}>Ekle</button>
        </div>

        {sesler.length === 0 ? (
          <div style={{ fontSize: 12.5, color: 'var(--text-muted)' }}>Henüz ses tanımlanmamış.</div>
        ) : (
          <div style={{ border: '1px solid var(--border)', borderRadius: 7, overflow: 'hidden' }}>
            {sesler.map(v => (
              <div key={v.id} style={{
                display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
                padding: '10px 12px', borderBottom: '1px solid var(--border)',
                opacity: v.aktif ? 1 : 0.55,
              }}>
                <strong style={{ fontSize: 13, minWidth: 90 }}>{v.ad}</strong>
                <span style={{ fontSize: 11.5, color: 'var(--text-muted)', minWidth: 110 }}>{v.etiket || '—'}</span>
                <span style={{ fontSize: 10.5, color: 'var(--text-muted)', fontFamily: 'monospace' }}>{v.sesKimligi}</span>
                <button onClick={() => sesDurum(v.id, !v.aktif).then(sesleriYukle)} style={{
                  marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer',
                  fontSize: 11, color: v.aktif ? '#C0392B' : '#1D7A56', textDecoration: 'underline',
                }}>{v.aktif ? 'devre dışı bırak' : 'geri aç'}</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
